export const DisableType = {
    hidden: "hidden",
    popover: "popover",
};

export const useFeatureFlag = () => {
    return {
        topHeaderMenuMyRecipesButton: {
            disabled: true,
            message: "My Recipes functionality is coming soon",
            disableType: DisableType.hidden,
        },
        dpdDeliveryMethodSelection: {
            disabled: true,
            message: "DPD is currently not supported",
            disableType: DisableType.hidden,
        },
        landingCouponSection: {
            disabled: true,
            message: "Coupons functionality is coming soon",
            disableType: DisableType.hidden,
        },
        reportUs: {
            disabled: true,
            message: "This feature will be available soon",
            disableType: DisableType.popover,
        },
        landingRegionalRecipesSection: {
            disabled: true,
            message: "Regional Recipes functionality is coming soon",
            disableType: DisableType.hidden,
        },
        layoutRegionalCountries: {
            disabled: true,
            message: "Regional Countries functionality is coming soon",
            disableType: DisableType.hidden,
        },
        desiFamily: {
            disabled: true,
            message: "This feature is in active development",
            disableType: DisableType.popover,
        },
        saveForLater: {
            disabled: true,
            message: "This feature is in active development",
            disableType: DisableType.popover,
        },
        myItems: {
            disabled: true,
            message: "This feature is in active development",
            disableType: DisableType.popover,
        },
        membership: {
            disabled: true,
            message: "This feature is in active development",
            disableType: DisableType.popover,
        },
        subscribeAndSave: {
            disabled: true,
            message: "This feature is in active development",
            disableType: DisableType.popover,
        },
    };
};
